import Component from 'components/pages/TermsAndConditions/TermsAndConditions.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('terms-and-conditions', {
  withoutHeaderOnMobile: true,
  withoutFooterOnMobile: true,
});
export default buildPage(Component, {
  requiresAuthentication: false,
  metaData: {
    title: 'Terms and Conditions',
    description:
      'The terms and conditions of our service, information about us, and service availability.',
  },
});
